import React, { useState, useCallback } from "react"

import Theme from 'components/basics/theme/Theme'
import Modals from 'components/modals/Modals/Modals'

import MobileMenu from '../c_new/MobileMenu/MobileMenu'
import Header from '../c_new/Header/Header'
import Footer from '../c_new/Footer/Footer'
import Cookie from '../c_new/Cookie/Cookie'

import * as st from './Main.styled.js'

const MainLayout = ({ children }) => {
  const [isOpenMobileMenu, setOpenMobileMenu] = useState(false);

  const onToggleMobileMenu = useCallback(() => (
    setOpenMobileMenu(isOpen => {
      const value = !isOpen
      document.body.style["overflow-y"] = value ? "hidden" : null
      return value
    })
  ), [])

  const onCloseMobileMenu = useCallback(() => {
    document.body.style["overflow-y"] = null
    setOpenMobileMenu(false)
  }, [])

  return (
    <Theme value="light">
      <MobileMenu
        isOpen={isOpenMobileMenu}
        onCloseMobileMenu={onCloseMobileMenu}
      />
      <st.Wrap>
        <Header
          isOpenMobileMenu={isOpenMobileMenu}
          onToggleMobileMenu={onToggleMobileMenu}
        />
        {children}
        <Footer />
      </st.Wrap>
      <Modals />
      <Cookie />
    </Theme>
  )
}

export default MainLayout
